import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { Observable, Subject } from 'rxjs';
import { DatabaseProvider } from '../../providers/database/database';
import { ClinicDoctorsAddPage } from '../clinic-doctors-add/clinic-doctors-add';

@IonicPage()
@Component({
  selector: 'page-clinic-doctors',
  templateUrl: 'clinic-doctors.html',
})
export class ClinicDoctorsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  public doctorsList: Observable<any[]>;
  clinic_name: string = null;
  clinic_id: string = null;

  user_is_admin: boolean;

  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    private modalCtrl: ModalController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.user_is_admin = user.roles.retina_admin || user.roles.clinic_admin;

      this.doctorsList = this.database
      .getDoctorsByClinic(this.clinic_id)
      .snapshotChanges()
      .takeUntil(this.ngUnsubscribe)
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave doctors and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  deleteDoctor(doctor)  {
    let confirm = this.alertCtrl.create({
      title: "Delete Doctor",
      message:
        "Are you sure you would like to delete this doctor?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.database.deleteDoctor(this.clinic_id, doctor.id).then(() => {
              this.database.deleteNursingHomesForDoctor(doctor.id);
              console.log('Successfully deleted the doctor');
            })
            .catch((error) => {
              console.log('Error deleting doctor');
            });
          }
        }
      ]
    });
    confirm.present();
  }

  editDoctor(doctor)  {
    console.log(doctor.id);
    const prompt = this.alertCtrl.create({
      title: 'Edit Dr. ' + doctor.first_name + ' ' + doctor.last_name,
      message: "Enter the first name, last name and license number",
      inputs: [
        {
          name: 'first_name',
          placeholder: 'First Name',
          value: doctor.first_name
        },
        {
          name: 'last_name',
          placeholder: 'Last Name',
          value: doctor.last_name
        }, {
          name: 'license_number',
          placeholder: 'License Number',
          value: doctor.license_number
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Update',
          handler: data => {
            this.database.updateDoctor(this.clinic_id, doctor.id, data).then(() => {
              console.log('Successfully updated the doctor');
            })
            .catch((error) => {
              console.log('Error updating the doctor');
            });
          }
        }
      ]
    });
    prompt.present();
  }

  doctorAddEdit(doctor) {
    let clinicModal = this.modalCtrl.create(ClinicDoctorsAddPage, {'doctordata': doctor} , {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/clinic-doctors/clinic-doctors.ts